module.exports = __webpack_public_path__ + "static/conference-1b6950913776eafb42502e0c7b5ef27c.svg";